import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buildHomeCitationSnippet } from '../../utils/homeCitationUrl';
import surface from './KensukeSurface.module.scss';

/**
 * 人間向けの引用ブロック（言語別 canonical URL を明示）。
 * llms.txt / sitemap は JSON-LD・link rel・公開ファイルで機械発見する（画面には出さない）。
 */
export default function KensukeCitationBlock() {
  const { t } = useTranslation();
  const location = useLocation();
  const citation = buildHomeCitationSnippet(
    t('home.cite_snippet_text', { defaultValue: t('home.cite_snippet') }),
    location.pathname
  );

  return (
    <section id="cite" className="py-4 bg-white border-top" aria-labelledby="home-cite-heading">
      <Container>
        <h2 id="home-cite-heading" className={surface.sectionHeading}>
          {t('home.cite_heading', { defaultValue: '引用・出典' })}
        </h2>
        <article
          className={`small text-muted mb-0 ${surface.requestsCard} ${surface.panelCompact}`}
          itemScope
          itemType="https://schema.org/WebPage"
        >
          <meta itemProp="name" content="kensuke-system" />
          <p className="mb-2">
            <cite className="fst-normal" itemProp="citation">
              {citation}
            </cite>
          </p>
          <p className="mb-0">{t('home.cite_attribution')}</p>
        </article>
      </Container>
    </section>
  );
}
